window.adInit = function() {
  var ad = $(".landing-advertise");

  if (!ad.length) return;
  $("body").css("overflow", "hidden");
  var timeoutId = undefined;
  var counter = ad.find("[data-counter]");
  var ctime = getParameterByName("ctime", ad.find("img").attr("src"));

  if (ctime) {
    counter.attr("data-counter", ctime);
  }

  function closeAd() {
    ad.addClass("ad-close");
    clearTimeout(timeoutId);
    $("body").removeAttr("style");
  }

  function countDown() {
    counter.attr("data-counter", counter.attr("data-counter") - 1);
    var count = counter.attr("data-counter");
    counter.text(count);
    if (count <= 0) {
      closeAd();
    } else {
      timeoutId = setTimeout(countDown, 1000);
    }
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  var imageLoaded = false;

  ad.find(".ad-image img").on("load", function() {
    timeoutId = setTimeout(countDown, 1000);
    imageLoaded = true;
  });

  setTimeout(function() {
    if (!imageLoaded) {
      timeoutId = setTimeout(countDown, 1000);
    }
  }, 5000);

  ad.find(".btn-close").click(closeAd);
};
